interface UserAuthFilter {
  identifyId?: {
    contains?: string
  }
  phoneNumber?: {
    contains?: string
  }
}

export const getUsers = (args: {
  where: {
    role: {
      is: {
        name: {
          equals: string
        }
      }
    }
    hnId?: {
      equals: number
    }
    UserAuth?: {
      is: {
        OR: UserAuthFilter[]
      }
    }
  }
  take?: number
  skip?: number
  dropDownListFlag?: boolean
}) => {
  let getUserQuery = `query getUsers($where: UserWhereInput ,$take: Int, $skip: Int, $orderBy: [UserOrderByWithRelationInput!])  {
                          getUsers(where: $where, take: $take, skip: $skip, orderBy: $orderBy)  {
                              uId
                              hnId
                              prefix
                              firstname
                              lastname
                              imagePath
                              ercId
                              docId
                              UserMedicalDemograhicData {
                                allergic
                                birthdate
                                province
                                district
                                userUnderlyingDiseaseTrasaction {
                                    uudtId
                                    underlyingDisease {
                                        udId
                                        medName
                                        thaiName
                                    }
                                }
                              }
                              UserAuth {
                                identifyId
                                phoneNumber
                              }
                              EnterpriseTreatmentPlace {
                                thaiName
                              }
                              createdAt
                          }
                      }`
  if (args.dropDownListFlag)
    getUserQuery = `query getUsers($where: UserWhereInput ,$take: Int, $skip: Int, $orderBy: [UserOrderByWithRelationInput!])  {
      getUsers(where: $where, take: $take, skip: $skip, orderBy: $orderBy)  {
        uId
        hnId
        prefix
        firstname
        lastname
        imagePath
        ercId
        docId
        UserMedicalDemograhicData {
          allergic
          birthdate
          province
          district
          userUnderlyingDiseaseTrasaction {
              uudtId
              underlyingDisease {
                  udId
                  medName
                  thaiName
              }
          }
        }
        UserAuth {
          identifyId
          phoneNumber
        }
        EnterpriseTreatmentPlace {
          thaiName
        }
        createdAt
      }
    }`

  let query: {
    query: string
    variables: {
      where: {
        role: {
          is: {
            name: {
              equals: string
            }
          }
        }
        hnId?: {
          equals: number
        }
        UserAuth?: {
          is: {
            OR: UserAuthFilter[]
          }
        }
      }
      take?: number
      skip?: number
      orderBy?: {
        createdAt: string
      }
    }
  } = {
    query: getUserQuery,
    variables: {
      where: {
        ...args.where,
      },
      orderBy: {
        createdAt: 'desc',
      },
    },
  }

  if (args.take)
    query = {
      ...query,
      variables: {
        ...query.variables,
        take: args.take,
      },
    }

  if (args.skip)
    query = {
      ...query,
      variables: {
        ...query.variables,
        skip: args.skip,
      },
    }

  return query
}

export const getCountUsers = (args: {
  where: {
    role: {
      is: {
        name: {
          equals: string
        }
      }
    }
    hnId?: {
      equals: number
    }
    UserAuth?: {
      is: {
        OR: UserAuthFilter[]
      }
    }
  }
  take: number
  skip: number
}) => {
  const getUserQuery = `query aggregateUser($where: UserWhereInput, $_count: UserCountAggregateInput)  {
                            aggregateUser(where: $where, _count: $_count)  {
                                _count {
                                    uId
                                }
                            }
                        }`

  return {
    query: getUserQuery,
    variables: {
      where: {
        ...args.where,
      },
      _count: {
        uId: true,
      },
    },
  }
}

export const getUser = () => {
  const getUserQuery = `query getUser ($where: UserWhereUniqueInput!) {
                          getUser (where: $where) {
                            prefix
                            firstname
                            lastname
                            imagePath
                            UserMedicalDemograhicData {
                              gender
                              birthdate
                              province
                              district
                            }
                          }
                        }`

  return {
    query: getUserQuery,
    variables: {
      where: {
        uId: '',
      },
    },
  }
}

export const getUserPatientUpdate = (uId) => {
  const getUserQuery = `query getUser ($where: UserWhereUniqueInput!) {
                          getUser (where: $where) {
                            prefix
                            firstname
                            lastname
                            imagePath
                            ercId
                            docId
                            hnId
                            UserMedicalDemograhicData {
                              gender
                              birthdate
                              province
                              district
                              subdistrict
                              postcode
                            }
                            UserAuth {
                              phoneNumber
                              identifyId
                              email
                            }
                          }
                        }`

  return {
    query: getUserQuery,
    variables: {
      where: {
        uId: uId,
      },
    },
  }
}

export const getUserDoctorUpdate = (uId) => {
  const getUserQuery = `query getUser ($where: UserWhereUniqueInput!) {
                          getUser (where: $where) {
                            prefix
                            firstname
                            lastname
                            imagePath
                            UserMedicalDemograhicData {
                              gender
                              birthdate
                              province
                              district
                            }
                            UserAuth {
                              phoneNumber
                              identifyId
                              email
                            }
                          }
                        }`

  return {
    query: getUserQuery,
    variables: {
      where: {
        uId: uId,
      },
    },
  }
}

export const getUserProfile = () => {
  const getUserQuery = `query getUser ($where: UserWhereUniqueInput!) {
                          getUser (where: $where) {
                            firstname
                            imagePath
                            hnId
                          }
                        }`

  return {
    query: getUserQuery,
    variables: {
      where: {
        uId: '',
      },
    },
  }
}

export const getEnterpriseTreatmentPlaces = () => {
  const getEnterpriseTreatmentPlaces = `query getEnterpriseTreatmentPlaces {
    getEnterpriseTreatmentPlaces{
        ercId
        thaiName
    }
}`

  return {
    query: getEnterpriseTreatmentPlaces,
  }
}
